export default require("../../../lib/webpack/emoji-loader!../../../vendor/emojis/img-apple-64.json");
